import { type PointOfSaleDto } from '../../../models/PointOfSale';
import { type CreatePushNotificationRequestDto } from '../../../models/CreatePushNotificationRequestDto';
import { type PushNotificationResponseDto } from '../../../models/PushNotificationResponseDto';
import { type UpdatePushNotificationRequestDto } from '../../../models/UpdatePushNotificationRequestDto';
import { type FormValues } from './_models';

export const toDateTimeLocalInput = (value: string | null): string => {
  if (!value) return '';
  // Backend returns ISO/LocalDateTime like "2030-01-15T10:30:00" — strip seconds for the input.
  return value.slice(0, 16);
};

export const fromDateTimeLocalInput = (value: string): string => {
  // datetime-local input gives "2030-01-15T10:30" — append seconds for the backend.
  return `${value}:00`;
};

export const mapResponseToFormValues = (
  dto: PushNotificationResponseDto,
  pointOfSale: PointOfSaleDto | null,
): FormValues => ({
  title: dto.title,
  body: dto.body,
  attachmentId: dto.attachment_id ?? null,
  imageUrl: dto.image_url ?? null,
  pointOfSale,
  targetApp: dto.target_app,
  sendNow: !dto.scheduled_for,
  scheduledFor: toDateTimeLocalInput(dto.scheduled_for ?? null),
});

const resolvePointOfSaleId = (values: FormValues): string | null =>
  values.targetApp === 'CLIENT_APP' ? (values.pointOfSale?.id ?? null) : null;

const resolveScheduledFor = (values: FormValues): string | null =>
  values.sendNow ? null : fromDateTimeLocalInput(values.scheduledFor);

export const mapFormValuesToCreatePayload = (values: FormValues): CreatePushNotificationRequestDto => ({
  title: values.title.trim(),
  body: values.body.trim(),
  attachment_id: values.attachmentId,
  target_app: values.targetApp,
  point_of_sale_id: resolvePointOfSaleId(values),
  scheduled_for: resolveScheduledFor(values),
  send_now: values.sendNow,
});

export const mapFormValuesToUpdatePayload = (values: FormValues): UpdatePushNotificationRequestDto => ({
  title: values.title.trim(),
  body: values.body.trim(),
  attachment_id: values.attachmentId,
  target_app: values.targetApp,
  point_of_sale_id: resolvePointOfSaleId(values),
  scheduled_for: resolveScheduledFor(values),
});
